import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentStatusCanceled = (props) => {
  const _themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="20"
        height="21"
        viewBox="0 0 20 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Annulé</title>
        <path
          d="M17.8233 2.43512L17.0865 1.61022C16.8542 1.35394 16.4858 1.35394 16.2536 1.61022L9.99875 8.66594L3.7359 1.60221C3.51165 1.34593 3.13524 1.34593 2.90299 1.60221L2.17419 2.43512C1.94194 2.69141 1.94194 3.11587 2.17419 3.37215L8.42903 10.4279L2.17419 17.4836C1.94194 17.7399 1.94194 18.1643 2.17419 18.4206L2.911 19.2455C3.14325 19.5018 3.51165 19.5018 3.74391 19.2455L9.99875 12.1898L16.2536 19.2455C16.4858 19.5018 16.8542 19.5018 17.0865 19.2455L17.8233 18.4206C18.0556 18.1643 18.0556 17.7399 17.8233 17.4836L11.5685 10.4279L17.8233 3.37215C18.0556 3.11587 18.0556 2.69141 17.8233 2.43512Z"
          fill="#CB1517"
        />
      </svg>
    </SvgIcon>
  );
};

export default PaymentStatusCanceled;
